import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  successResponse: {},
  isLoading: false,
  isError: false,
  error: false
};
const forgotMemberIdSlice = createSlice({
  name: "forgotMemberId",
  initialState,
  reducers: {
    forgotMemberIdRequest: (state, action) => {
      state.isLoading = true;
      state.error = false;
      state.isError = false;
    },
    forgotMemberIdSuccess: (state, action) => {
      state.isLoading = false;
      state.error = "";
      state.hasData = true;
      state.successResponse = action.payload;
    },
    forgotMemberIdFailure: (state, action) => {
      state.error = action?.payload?.data;
      state.isLoading = false;
      state.isError = true;
    },
    resetForgotMemberId: state => {
      state.successResponse = {};
      state.isLoading = false;
      state.isError = true;
      state.error = false;
    }
  }
});
export const {
  forgotMemberIdRequest,
  forgotMemberIdSuccess,
  forgotMemberIdFailure,
  resetForgotMemberId
} = forgotMemberIdSlice.actions;
export default forgotMemberIdSlice.reducer;